import config from 'config/appConfig';
import { DivConst } from 'constants/divConst';
import { AppHelper } from './appHelper';

export class QuizHelper {
  /**
   * クイズのプレビューURLを取得します。
   */
  static getPreviewUrl(quizPreviewCd: string): string {
    return `${config.url.userWeb}/quiz/preview/${quizPreviewCd}`;
  }

  /**
   * クイズのプレビューURLを開きます。
   */
  static openPreviewUrl(quizPreviewCd: string): void {
    window.open(this.getPreviewUrl(quizPreviewCd), '_blank');
  }

  /**
   * クイズの公開URLを取得します。
   */
  static getProductionUrl(quizCd: string): string {
    return `${config.url.userWeb}/quiz/${quizCd}`;
  }

  /**
   * クイズの公開URLを開きます。
   */
  static openProductionUrl(quizCd: string): void {
    window.open(this.getProductionUrl(quizCd), '_blank');
  }

  /**
   * クイズのLINE公開URLを取得します。
   */
  static getLineProductionUrl(quizCd: string): string {
    return `${config.url.userWeb}/quiz/line/${quizCd}`;
  }

  /**
   * クイズのLINE公開URLを開きます。
   */
  static openLineProductionUrl(quizCd: string): void {
    window.open(this.getLineProductionUrl(quizCd), '_blank');
  }

  /**
   * 公開期間の文字列を作成します。。
   * こうかい予定日よりも公開日を優先して表示します。
   */
  static formatPublishTerm(props: {
    quizStatusDiv: number;
    publishStartAt: number;
    publishEndAt: number;
    publishedAt: number;
    terminatedAt: number;
  }): string {
    let startAt = null;
    let endAt = null;

    // 予約ステータスの場合は、予約日を優先
    if (props.quizStatusDiv == DivConst.items.quizStatus.reserved.value) {
      startAt = props.publishStartAt;
      endAt = props.publishEndAt;
    }
    // その他のステータスの場合は、公開実績を優先
    else {
      startAt = AppHelper.isNotEmpty(props.publishedAt) ? props.publishedAt : props.publishStartAt;

      endAt = AppHelper.isNotEmpty(props.terminatedAt) ? props.terminatedAt : props.publishEndAt;
    }

    if (AppHelper.isEmpty(startAt) && AppHelper.isEmpty(endAt)) {
      return '指定なし';
    }
    if (AppHelper.isEmpty(startAt) && AppHelper.isNotEmpty(endAt)) {
      return `${AppHelper.formatTimeToDate(
        new Date().getTime(),
        'yyyy/MM/dd'
      )} 〜 ${AppHelper.formatTimeToDate(endAt, 'yyyy/MM/dd')}`;
    }
    if (AppHelper.isNotEmpty(startAt) && AppHelper.isEmpty(endAt)) {
      return `${AppHelper.formatTimeToDate(startAt, 'yyyy/MM/dd')} 〜 無期限`;
    }

    return `${AppHelper.formatTimeToDate(startAt, 'yyyy/MM/dd')} 〜 ${AppHelper.formatTimeToDate(
      endAt,
      'yyyy/MM/dd'
    )}`;
  }
}
